const SEARCH_SUBMIT_BUTTON_SX = {
    px: { xs: 3, md: 2.5 },
    borderRadius: 2,
    minHeight: { xs: 44, md: 38 },
    whiteSpace: 'nowrap',
    textTransform: 'none',
};

export default SEARCH_SUBMIT_BUTTON_SX;
